import type { FC } from 'react';

import { useUnsubscribePage } from '@/features/legal/hooks/useUnsubscribePage.hook';

const UnsubscribePage: FC = () => {
  const { state, message } = useUnsubscribePage();

  return (
    <article className="bg-white">
      <div className="mx-auto w-full max-w-2xl px-5 py-20 text-center md:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-600">
          Email preferences
        </p>
        <h1 className="mt-3 font-display text-4xl font-extrabold text-[var(--color-ink)]">
          {state === 'working' ? 'One moment…' : state === 'done' ? "You're unsubscribed" : 'Link not valid'}
        </h1>
        <p className="mt-4 text-base leading-relaxed text-[var(--color-ink-muted)]">
          {state === 'working' ? 'Updating your email preferences.' : message}
        </p>
        {state === 'done' ? (
          <p className="mt-6 text-sm text-[var(--color-ink-soft)]">
            Changed your mind? Just open the Shoutt app and finish setting up your account — no
            email needed.
          </p>
        ) : null}
      </div>
    </article>
  );
};

export default UnsubscribePage;
